import { connect } from 'react-redux';
import { selectIsMobile } from 'redux/modules/device';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { CreditsFilter } from '../components/filters/CreditsFilter';
import { searchFilterActions, selectSelectedCreditsRange } from './filters.helpers';
import { filterChanged } from './filters.saga';
import { FILTER_NAMES } from '../Search.constants';

const { clearFilter, setFilterEditing } = searchFilterActions;

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const filterData = deepExtract(`${FILTER_NAMES.CREDITS}`, filters, {});
  const isOutOfSync = filterData.needsUpdate || false;
  const isEditing = filterData.isEditing || false;
  const creditsRange = selectSelectedCreditsRange(state);
  const isSelected = filterData.filtered || false;

  return {
    isMobile: selectIsMobile(state),
    isSelected,
    isOutOfSync,
    isEditing,
    creditsRange,
  };
};

const mapDispatchToProps = {
  onSyncFilter: () => filterChanged(FILTER_NAMES.CREDITS),
  onClear: () => clearFilter(FILTER_NAMES.CREDITS),
  onSetIsEditing: isEditing => setFilterEditing(FILTER_NAMES.CREDITS, isEditing),
};

export const CreditsFilterContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('CreditsFilterContainer')
)(CreditsFilter);
